import SJButton from '@/components/SJButton'
import { Certification, CertificationListRes } from '@/services/types/accredit'
import { getCertification } from '@/services/accredit'
import { useEffect, useState } from 'react'
import CertPic from './components/CertPic'
import { Swiper, Toast } from 'antd-mobile'
import { useSearchParams } from 'react-router-dom'
import user from '@/stores/user'
import './index.less'

// type State = {
//   playerId: string
//   current: string
// }
const RegistrationCertificates = () => {
  document.title = '评测证书'
  const [searchParams] = useSearchParams()
  const playerId = searchParams.get('playerId')
  const current = searchParams.get('current')
  const [certificates, setCertificates] = useState<Certification[]>([])
  const [swiperCur, setSwiperCur] = useState(0)

  const [previewImage, setPreviewImage] = useState('')

  useEffect(() => {
    current && setSwiperCur(Number.parseInt(current))
    playerId && loadCerts(playerId)
  }, [])

  const loadCerts = async (playerId: string) => {
    try {
      Toast.show({
        icon: 'loading',
        content: '加载中···',
        duration: 2000,
      })
      const res = (await getCertification({
        applicant_id: playerId,
      })) as unknown as CertificationListRes
      setCertificates(res.certification)
    } catch (error) {}
  }

  const handleDownload = () => {
    try {
      const canvasId = getId(certificates[swiperCur])
      console.log(canvasId)
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement
      const data = canvas?.toDataURL('image/png', 0.92)
      if (data) {
        console.log('生成图片ok', data.length)
        user.from === 'CMCC' ? saveFileCmcc(data) : setPreviewImage(data)
      }
      // data && saveFile(data, 'png', '证书')
    } catch (err) {
      console.log(`Error: ${err}`)
    }
  }

  // const saveFile = (strData: string, fileType: string, fileName = 'name') => {
  //   console.log('saveFile')
  //   // document.location.href = strData;
  //   let saveLink = document.createElement('a')
  //   // download file name
  //   saveLink.download = fileName + '.' + fileType
  //   // download file data
  //   saveLink.href = strData
  //   // start download
  //   saveLink.click()
  // }

  const saveFileCmcc = (strData: string) => {
    ;(window as any).bridge.callHandler(
      'saveImg',
      {
        imgBase64String: strData,
      },
      function responseCallback(responseData: any) {
        console.log(responseData)
      },
    )
  }

  const getId = (cert: Certification) => {
    return cert.id !== undefined ? 'cert_' + cert.id.toString() : 'cert'
  }

  return (
    <div className="page registration-certificates">
      <Swiper
        style={{ width: '100%', height: 'calc(100vh - 100px)' }}
        loop
        defaultIndex={Number(current)}
        onIndexChange={setSwiperCur}
      >
        {certificates.map((cert: Certification, index: number) => {
          return (
            <Swiper.Item key={cert.id}>
              <div className="swiper">
                <CertPic certificate={cert} canvasId={getId(cert)} />
              </div>
            </Swiper.Item>
          )
        })}
      </Swiper>
      <SJButton style={{ marginTop: '20px' }} type="primary" size="large" onClick={handleDownload}>
        下载证书
      </SJButton>
      {previewImage && (
        <div className="preview" onClick={() => setPreviewImage('')}>
          <img className="preview-img" src={previewImage} alt="证书" />
          <div className="preview-tip">长按保存图片</div>
        </div>
      )}

      {/* <img
        id="certBg"
        src={require('./components/cert_bg.jpg')}
        alt=""
        width="100"
        style={{ position: 'absolute', top: '10000px' }}
      /> */}
    </div>
  )
}

export default RegistrationCertificates
